import React, { createContext, useCallback, useContext, useState } from 'react';

const SidebarContext = createContext();
const SIDEBAR_OPEN_KEY = 'bansel_sidebar_open';

const readSidebarOpen = () => {
    try {
        const raw = localStorage.getItem(SIDEBAR_OPEN_KEY);
        if (raw === null) return true;
        return raw === '1' || raw === 'true';
    } catch {
        return true;
    }
};

export const SidebarProvider = ({ children }) => {
    const [isOpen, setIsOpenState] = useState(readSidebarOpen);

    const setIsOpen = useCallback((value) => {
        setIsOpenState((prev) => {
            const next = typeof value === 'function' ? value(prev) : value;
            try {
                if (typeof window === 'undefined' || window.innerWidth > 768) {
                    localStorage.setItem(SIDEBAR_OPEN_KEY, next ? '1' : '0');
                }
            } catch {
                /* ignore */
            }
            return next;
        });
    }, []);

    return (
        <SidebarContext.Provider value={{ isOpen, setIsOpen }}>
            {children}
        </SidebarContext.Provider>
    );
};

export const useSidebar = () => {
    const context = useContext(SidebarContext);
    if (!context) {
        throw new Error('useSidebar must be used within a SidebarProvider');
    }
    return context;
};
